export default __webpack_public_path__ + "static/media/axe_throwing.4eb5cf24.png";